var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-wizard-base',{attrs:{"title":_vm.$t('event_wizard.edit_title', { event: _vm.event.name }),"progress":100,"eventId":parseInt(_vm.$route.params.eventId)},on:{"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }